import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Paper,
  Button,
  Divider 
} from '@mui/material';

// 导入图片
import aboutBg from '../assets/images/about/aboutBg.png';
import endPng from '../assets/images/about/endPng.png';
import endTwo from '../assets/images/about/endTwo.png';

const About = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box sx={{ position: 'relative', mb: 6 }}>
        <img 
          src={aboutBg} 
          alt="About Us Background" 
          style={{ width: '100%', display: 'block' }}
        />
        <Box 
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            width: '100%',
            padding: '0 2rem',
            color: 'white'
          }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            About Us
          </Typography>
          <Typography variant="h5">
            了解我们的故事
          </Typography>
        </Box>
      </Box>

      {/* Mission Section */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              我们的使命
            </Typography>
            <Typography variant="h5" gutterBottom>
              Our Mission
            </Typography>
            <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 3, borderRadius: '2px' }} />
            <Typography variant="body1" paragraph>
              在Destiny-Crystal，我们致力于将古老的命理智慧与现代科技融合，创造一个独特的平台，帮助人们理解自己的命运轨迹，同时通过精选的水晶饰品增强个人能量场。
            </Typography>
            <Typography variant="body1" paragraph>
              我们相信，每一颗水晶都拥有独特的频率和能量，能够与人体产生共鸣，带来平衡与和谐。通过AI算命技术和真人命理师的专业解读，我们为您提供个性化的命运指引，并推荐最适合您的水晶饰品。
            </Typography>
            <Typography variant="body1">
              我们的目标不仅是销售产品，更是创造一种生活方式——让古老的智慧在现代生活中焕发新的活力，帮助人们找到内心的平静与力量。
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={endPng}
              alt="Our Mission"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Our Story Section */}
      <Box sx={{ bgcolor: '#f8f5fb', py: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={endTwo}
                alt="Our Story"
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" gutterBottom>
                我们的故事
              </Typography>
              <Typography variant="h5" gutterBottom>
                Our Story
              </Typography>
              <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 3, borderRadius: '2px' }} />
              <Typography variant="body1" paragraph>
                Destiny-Crystal由一群对古老命理学和水晶能量充满热情的专业人士创立。我们的创始团队包括经验丰富的命理师、珠宝设计师和科技专家，共同打造了这个将传统智慧与现代技术完美结合的平台。
              </Typography>
              <Typography variant="body1" paragraph>
                我们的水晶均来自全球精选矿区，经过严格的品质筛选和能量净化，确保每一件饰品都保持其最纯净的状态。我们与多位资深命理师合作，不断完善我们的AI算法，使其能够提供更准确的命运解读。
              </Typography>
              <Typography variant="body1">
                从最初的小型工作室到如今的综合性平台，我们始终坚持"诚信为本，品质至上"的理念，希望为每一位顾客提供最优质的产品和服务。
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Values Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" align="center" gutterBottom>
          我们的核心价值观
        </Typography>
        <Typography variant="h5" align="center" gutterBottom>
          Our Core Values
        </Typography>
        <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#9c27b0', mb: 5, mx: 'auto', borderRadius: '2px' }} />
        
        <Grid container spacing={4} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="h5" gutterBottom color="primary">
                真实与诚信
              </Typography>
              <Typography variant="body1">
                我们承诺提供真实的命理解读和高品质的水晶产品，不夸大功效，不误导消费者，保持最高的职业道德标准。
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="h5" gutterBottom color="primary">
                尊重与包容
              </Typography>
              <Typography variant="body1">
                我们尊重每个人的信仰和文化背景，提供包容性的服务，帮助不同的人找到适合自己的命运指引和能量工具。
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="h5" gutterBottom color="primary">
                创新与传承
              </Typography>
              <Typography variant="body1">
                我们致力于创新技术的应用，同时尊重和传承古老的命理智慧，创造出独特的现代命理体验。
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Call to Action */}
      <Box sx={{ bgcolor: '#9c27b0', color: 'white', py: 8, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom>
            开始您的命理之旅
          </Typography>
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            无论您是想了解自己的命运走向，还是寻找能增强个人能量的水晶饰品，Destiny-Crystal都能为您提供专业的指引。
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Button 
              variant="contained" 
              color="secondary"
              sx={{ px: 4, py: 1.5, fontSize: '1rem' }}
              href="/ai-fortune"
            >
              AI算命体验
            </Button>
            <Button 
              variant="outlined" 
              sx={{ 
                px: 4, 
                py: 1.5, 
                fontSize: '1rem', 
                borderColor: 'white', 
                color: 'white',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
              href="/shop"
            >
              浏览水晶饰品
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default About;